export default __webpack_public_path__ + "static/kurorty-img-12-1f55b414273a305a828cd5db9a24def9.png";